import { definePreset, palette } from "@primeuix/themes";
import Lara from '@primeuix/themes/lara';

const sagaBluePalette = palette("#2196f3");  //made a custom palette of sagablue color theme

export const LaraSagaBluePreset = definePreset(Lara, {
  semantic: {
    primary: sagaBluePalette,
    // primary: palette('{blue}')   // use blue palette instead
  },
  components: {
    accordion: {
      header: {
        color: '#495057',
        padding: '10px'
      },
      content: {
        borderWidth: '1px',
        borderColor: '#dddddd',
        padding: '0.5rem'
      }
    },
    checkbox: {
      root: {
        width: '20px',
        height: '20px',
        borderColor: '#ced4da'
      },
      icon: {
        disabledColor: "#ffffff"
      }
    },
    datatable: {
      columnTitle: {
        fontWeight: "600"
      },
      headerCell:{
        color: '#ea5831',
        hoverColor:'#23527c',
        selectedColor:'#23527c',
      },
      colorScheme: {
        light: {
          headerCell:{
            color: '#ea5831',
            background:"#f9f9f9"
          }
        }
      }
    },
    datepicker: {
      panel: {
        padding: '0.5rem'
      },
      colorScheme: {
        light: {
          dropdown: {
            borderColor: "transparent",
            hoverBorderColor: "transparent",
            activeBorderColor: "transparent",
            background: '#2196f3',
            hoverBackground: '#0d89ec',
            activeBackground: '#0b7ad1',
            color: '#ffffff',
            hoverColor: '#ffffff',
            activeColor: '#ffffff',
          }
        }
      }
    },
    togglebutton: {
      root: {
        checkedBackground: '#2196f3',
        checkedColor: '#ffffff',
      }
    }
  }
});
